exports.components = {
  "component---src-pages-404-tsx": () => import("./../../../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */),
  "component---src-templates-home-home-unilever-digital-tsx": () => import("./../../../src/templates/home/Home.unilever-digital.tsx" /* webpackChunkName: "component---src-templates-home-home-unilever-digital-tsx" */),
  "component---src-templates-landing-page-landing-page-tsx": () => import("./../../../src/templates/landingPage/LandingPage.tsx" /* webpackChunkName: "component---src-templates-landing-page-landing-page-tsx" */)
}

